import * as React from 'react';
const SvgYoutubeNonSkippable = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={88}
    height={88}
    fill="none"
    viewBox="0 0 88 88"
    {...props}
  >
    <g clipPath="url(#a)">
      <path fill="#fff" fillOpacity={0.01} d="M0 0h88v88H0z" />
      <rect width={88} height={88} fill="#fff" rx={4} />
      <path
        fill="#16E"
        d="M4 28a2 2 0 0 1 2-2h76a2 2 0 0 1 2 2v40a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
        opacity={0.6}
      />
      <rect
        width={79}
        height={43}
        x={4.5}
        y={26.5}
        stroke="currentColor"
        strokeOpacity={0.14}
        rx={1.5}
      />
      <rect
        width={40}
        height={2}
        x={4}
        y={20}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={64}
        height={2}
        x={4}
        y={16}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={12}
        height={2}
        x={14}
        y={9}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={22}
        height={2}
        x={14}
        y={5}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.8}
        rx={1}
      />
      <rect
        width={8}
        height={8}
        x={4}
        y={4}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.8}
        rx={2}
      />
      <rect
        width={87}
        height={87}
        x={0.5}
        y={0.5}
        stroke="currentColor"
        strokeOpacity={0.14}
        rx={3.5}
      />
      <path
        fill="#fff"
        d="M38.2 55.611c-.2-.26-.2-.73-.2-1.66v-11.9c0-.93 0-1.4.2-1.66.07-.1.16-.18.26-.24.13-.08.29-.14.46-.15.33-.02.73.23 1.52.74l9.335 5.95c.69.44 1.03.66 1.15.94a1 1 0 0 1 0 .76c-.12.28-.46.5-1.15.94l-9.334 5.93c-.79.51-1.19.76-1.52.74a.97.97 0 0 1-.72-.39"
      />
      <rect
        width={16}
        height={2}
        x={4}
        y={78}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={32}
        height={2}
        x={4}
        y={74}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={13}
        height={5}
        x={70.5}
        y={74.5}
        stroke="currentColor"
        strokeOpacity={0.14}
        rx={0.5}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M59.4 59a2.4 2.4 0 0 0-2.4 2.4v4.2a2.4 2.4 0 0 0 2.4 2.4h20.2a2.4 2.4 0 0 0 2.4-2.4v-4.2a2.4 2.4 0 0 0-2.4-2.4zm1.852 7v-4.364h-.867l-1.08.684v.819l.999-.627h.026V66zm1.826-.106q.353.165.805.166.486 0 .852-.194.369-.196.573-.537.207-.343.205-.784a1.5 1.5 0 0 0-.177-.742 1.34 1.34 0 0 0-.488-.509 1.34 1.34 0 0 0-.703-.185q-.288 0-.52.106a.84.84 0 0 0-.347.269h-.026l.113-1.093h1.907v-.755h-2.667l-.207 2.301.82.148a.7.7 0 0 1 .28-.216.9.9 0 0 1 .372-.078.8.8 0 0 1 .39.1.7.7 0 0 1 .266.272.8.8 0 0 1 .099.405.8.8 0 0 1-.096.4.7.7 0 0 1-.263.271.75.75 0 0 1-.383.096.73.73 0 0 1-.47-.157.55.55 0 0 1-.214-.412h-.895q.01.378.215.67.207.291.559.457m5.126-1.716v-.72h-1.99v.72zm.642 1.157V66h3.11v-.754h-1.832v-.03l.637-.624q.45-.41.697-.701.248-.295.343-.535.099-.24.098-.488 0-.377-.194-.67a1.3 1.3 0 0 0-.543-.455 1.9 1.9 0 0 0-.816-.166q-.456 0-.806.172a1.3 1.3 0 0 0-.543.488 1.4 1.4 0 0 0-.194.744h.876q0-.21.08-.36.082-.151.231-.233a.7.7 0 0 1 .35-.08q.191 0 .343.076a.57.57 0 0 1 .325.546.75.75 0 0 1-.07.321 1.3 1.3 0 0 1-.207.3q-.134.154-.332.346zm4.544.49q.397.27.946.27.55 0 .944-.268.395-.269.605-.777.213-.51.213-1.228.002-.713-.21-1.214a1.7 1.7 0 0 0-.61-.767 1.65 1.65 0 0 0-.942-.264q-.548 0-.944.264a1.67 1.67 0 0 0-.607.765q-.21.502-.211 1.216-.002.716.209 1.226.213.51.607.777m1.545-.871q-.225.377-.599.377a.63.63 0 0 1-.434-.166q-.186-.168-.288-.503a3 3 0 0 1-.1-.84q.001-.742.226-1.116.224-.373.596-.373.249 0 .433.166.184.167.285.497.102.33.102.826.003.754-.221 1.132m3.722-1.242.83-.052a1.01 1.01 0 0 0-.417-.713q-.355-.262-.976-.262-.42 0-.733.123-.31.124-.484.352a.88.88 0 0 0-.17.543q0 .366.232.603.236.237.714.332l.567.113a.75.75 0 0 1 .315.124.25.25 0 0 1 .105.202q-.003.148-.15.241a.7.7 0 0 1-.383.092.7.7 0 0 1-.398-.102.46.46 0 0 1-.197-.303l-.892.047q.066.469.45.741.385.27 1.035.27.426 0 .752-.133.328-.137.516-.38a.9.9 0 0 0 .19-.564.74.74 0 0 0-.235-.571q-.235-.217-.712-.316l-.592-.119q-.229-.05-.322-.13a.25.25 0 0 1-.094-.198q0-.147.145-.234a.67.67 0 0 1 .356-.09.6.6 0 0 1 .27.053q.116.051.186.139.07.085.092.192"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h88v88H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgYoutubeNonSkippable;
